export default __webpack_public_path__ + "static/import-button-a9427a329cda48488cba69e0bafb62c8.png";